import InternalEvent from "../../../core/constants/internalEvent";
import InternalEventBus from "../../../core/utils/internalEventBus";
import UniqueIdGenerator from "../../../core/utils/uniqueIdGenerator";

export class TimeSeriesController {
  constructor(widget, updateCallback, historySize = 40) {
    this.id = UniqueIdGenerator.uuid();
    this.widget = widget;
    this.eventTokens = [];
    this.historySize = historySize;
    this.updateCallback = updateCallback;
  }

  subscribeEvent(event, handler) {
    const token = InternalEventBus.subscribe(event, handler);
    this.eventTokens.push(token);
  }

  loadHistoricData (historicData, noOfRecords) {
    console.log(historicData);
  }

  /***
   * snapshotData {
   *    dataset1: [...],
   *    dataset2: [...],
   *    ..
   * }
   *
   *
   * @param snapshotData
   * @returns {Array}
   */
  processingSnapshotData(snapshotData) {
    let data = [];
    let numberOfSnapshotDataRecords;
    for (let prop in snapshotData) {
      numberOfSnapshotDataRecords = snapshotData[prop].length;
    }
    const datasetIds = Object.keys(snapshotData);
    this.widget.legends.map((legend, legendIndex) => {
      data.push([]);

      for (let i = 0; i < numberOfSnapshotDataRecords; i++) {
        let datasetsData = {};

        /**
         * {
         *  dataset1: data,
         *  dataset2: data,
         *  dataset3: null,
         *  ...
         *  time: time,
         * }
         */
        for (let key in legend.mappings) {
          let datasetId = legend.mappings[key].datasetId;
          if (snapshotData.hasOwnProperty(datasetId)) {
            datasetsData[datasetId] = snapshotData[datasetId][i];
          } else {
            datasetsData[datasetId] = null;
          }
        }

        // find the current window's timestamp
        for (let j = 0; j < datasetIds.length; j++) {
          const data = snapshotData[datasetIds[j]][i];
          if (data && data.isMyDatasetUpdate) {
            datasetsData.time = data.epochSecond;
            break;
          }
        }

        if (legend.hasOwnProperty("serverSideFunction")) {
          if(!Array.isArray(legend.serverSideFunction)) {
            legend.serverSideFunction = [legend.serverSideFunction];
          }
          legend.serverSideFunction.map(ssf => {
            const requestId = ssf.requestId;
            datasetsData[requestId] = snapshotData[requestId][i];
            if (datasetsData[requestId] != null) {
              datasetsData.time = datasetsData[requestId].epochSecond;
            }
          });
        }

        for (let key in legend.functions) {
          let yValue = null;
          try {
            yValue = legend.functions[key](datasetsData);
          } catch (e) {
          }
          datasetsData[key] = yValue;
        }

        if (this.isLegendBubble(legend)) {
          // let isMyUpdate = myUpdateFlagSetter.setFlag(datasetsData,
          //   updatingDatasetId,
          //   legend.functions.filter);
          //
          // if (!isMyUpdate) {
          //   datasetsData.y = null;
          // }
        }
        datasetsData.legendId = legend.id;
        data[legendIndex].push(datasetsData);
      }
    });

    return data;
  }

  isLegendBubble(legend) {
    return legend.parameters.chartType === 'bubble';
  }

  getHistorySize() {
    return this.historySize;
  }

  getLegends() {
    return this.widget.legends;
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/timeSeriesController.js